import { ChatSituations } from 'utils/fuctions/mapSituationChat';

const filterByTag = (chatCurrent, filters) => {
  if (!chatCurrent || !filters) return false;
  if (!filters['TAG']?.length) return false;
  if (
    filters['TAG']?.length &&
    (!chatCurrent?.tags || !chatCurrent?.tags?.length)
  )
    return false;
  let exists = false;
  const tags = chatCurrent?.tags || [];

  tags.forEach((tag) => {
    if (exists) return true;
    if (tag) {
      if (filters['TAG'].includes(tag)) exists = true;
      else exists = false;
    }
  });

  return exists;
};

const filterActiveContact = (chat, filters) => {
  if (!filters['START_TYPE']?.length) return false;
  if (filters['START_TYPE'] === 'ACTIVE' && chat.isContatoAtivo) return true;
  if (filters['START_TYPE'] === 'RECEPTIVE' && !chat.isContatoAtivo)
    return true;
  return false;
};

const filterByQueue = (chat, filters) => {
  const queues = filters['FILA'];
  if (!queues.length) return false;
  if (queues.includes(chat?.fila)) return true;
  return false;
};

export const filterConversation = (chat, str) => {
  if (!str) return true;

  const cliente = chat.cliente;

  if (!cliente) return false;

  const searchStr = str.toLowerCase();

  const clienteProps = Object.keys(cliente);

  return clienteProps.some((prop) => {
    const excludedFields = [
      'id',
      'was_created_automatically',
      'account_id',
      'created_at',
      'created_by',
      'last_updated_at',
      'last_updated_by',
      'record_type_id',
      'latitude',
      'longitude'
    ];

    if (excludedFields.includes(prop)) return false;

    const handleCpfCnpjInputSearch = (input) => {
      return input.replace('-', '').replace('.', '').replace('/', '');
    };

    return typeof cliente[prop] === 'string'
      ? cliente[prop]
          .toLowerCase()
          .includes(handleCpfCnpjInputSearch(searchStr))
      : false;
  });
};

const filterBySaved = (chat, filters, chatsSaved) => {
  if (filters['CHATS_SAVED']) return chatsSaved?.has(chat.id);
  return false;
};

const filterChatWithoutAgentInteractionWarning = (
  chat,
  filters,
  chatIds = new Set()
) => {
  if (filters['INTERACTION_AGENT_WARNING'])
    return chatIds?.has(chat?.id || chat?._id);

  return false;
};

const filterChatWithoutAgentInteractionCritical = (
  chat,
  filters,
  chatIds = new Set()
) => {
  if (filters['INTERACTION_AGENT_CRITICAL'])
    return chatIds?.has(chat?.id || chat?._id);

  return false;
};

const filterChatWithResponseAgent = (chat, filters, chatIds = new Set()) => {
  if (filters['CHATS_WITH_RESPONSE_AGENT'])
    return chatIds?.has(chat?.id || chat?._id);

  return false;
};

const filterChatWithoutCustomerInteraction = (
  chat,
  filters,
  customerWithInteractionCritical
) => {
  if (filters['INTERACTION_CLIENT'])
    return customerWithInteractionCritical.has(chat.id);

  return false;
};

const filterByStatus = (chat, filters) => {
  const statusFilter = filters['STATUS'];

  if (!statusFilter.length) return false;

  switch (statusFilter) {
    case 'ANSWERED':
      return chat.situacao === ChatSituations.IN_ATTENDANCE;
    case 'UNANSWERED':
      return chat.situacao !== ChatSituations.IN_ATTENDANCE;
    default:
      return false;
  }
};

export const filterss = (
  chat,
  filters,
  search,
  chatsSaved,
  chatAgentsWithoutInteractionCritical = new Set(),
  chatAgentsWithoutInteractionWarning = new Set(),
  chatsWithResponseAgent = new Set(),
  customerWithInteractionCritical
) => {
  if (chat?.situacao === ChatSituations.WAITING_IN_QUEUE) return false;
  return (
    filterActiveContact(chat, filters) ||
    filterByQueue(chat, filters) ||
    filterBySaved(chat, filters, chatsSaved) ||
    filterChatWithoutAgentInteractionCritical(
      chat,
      filters,
      chatAgentsWithoutInteractionCritical
    ) ||
    filterChatWithoutAgentInteractionWarning(
      chat,
      filters,
      chatAgentsWithoutInteractionWarning
    ) ||
    filterByTag(chat, filters) ||
    filterChatWithResponseAgent(chat, filters, chatsWithResponseAgent) ||
    filterByStatus(chat, filters) ||
    filterChatWithoutCustomerInteraction(
      chat,
      filters,
      customerWithInteractionCritical
    )
  );
};
